export const RENDER_CRYPTOS_REQUEST = " RENDER_CRYPTOS_REQUEST";
export const RENDER_CRYPTOS = "RENDER_CRYPTO";
export const RENDER_CRYPTOS_FAILED = "RENDER_CRYPTOS_FAILED";

export const RENDER_ALL_CRYPTOS_REQUEST = "RENDER_ALL_CRYPTOS_REQUEST";
export const RENDER_ALL_CRYPTOS = "RENDER_ALL_CRYPTOS";
export const RENDER_ALL_CRYPTOS_FAILED = "RENDER_ALL_CRYPTOS_FAILED";
